var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBot3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9.5,
    cy: 9.5,
    r: 9.5,
    fill: "#546EDB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 14.5281V7.42894H11.1852C10.984 7.42894 10.8211 7.25311 10.8211 7.03601V4H6.43753C6.1962 4 6 4.21175 6 4.47205V14.5281C6 14.7884 6.19622 15 6.43753 15H13.5622C13.8036 15 14 14.7884 14 14.5281ZM11.5494 6.64321V4.55558L13.4848 6.64321H11.5494ZM12.6042 12.4226C12.6042 12.6394 12.4411 12.8155 12.2399 12.8155H7.75992C7.55888 12.8155 7.39563 12.6395 7.39563 12.4226C7.39563 12.2055 7.55888 12.0298 7.75992 12.0298H12.2399C12.4411 12.0298 12.6042 12.2055 12.6042 12.4226ZM12.6042 9.74129C12.6042 9.95826 12.4411 10.1341 12.2399 10.1341H7.75992C7.55888 10.1341 7.39563 9.95826 7.39563 9.74129C7.39563 9.52432 7.55888 9.34849 7.75992 9.34849H12.2399C12.4411 9.34849 12.6042 9.52432 12.6042 9.74129Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBot3);
export default __webpack_public_path__ + "static/media/bot3.2d20f29e52cbf77a1e4ccce3512a6273.svg";
export { ForwardRef as ReactComponent };